import axios from "@/utils/server.js"
//查询树形格式模板列表
export const getFormatTemplateTreeSer = () => axios.get("/template/format/tree")
    //添加策略模板
export const addStrtegSer = (data) => axios.post("/template/policy", null, { params: data })
    // 获取策略模板列表
export const getStrtegListSer = (datas) => axios.get("/template/policy/list", { params: datas })
    //删除策略模板
export const deleteStrtegSer = (datas) => axios.delete("/template/policy", { params: datas })
    //获取策略模板详情
export const getStrtegSer = (datas) => axios.get("/template/policy/roles", { params: datas })
    //修改策略模板
export const editStrtegSer = (datas) => axios.put("/template/policy", null, { params: datas })